import { useEffect, useRef } from 'react';

/** Calls `callback` every display frame while `enabled` (the latest callback, without re-binding the loop). */
export function useAnimationFrame(callback: () => void, enabled: boolean): void {
  const cbRef = useRef(callback);
  cbRef.current = callback;
  useEffect(() => {
    if (!enabled) return undefined;
    let raf = 0;
    const loop = () => { cbRef.current(); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, [enabled]);
}
